import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { Auth } from 'src/api';
import { SaveBtn, Input } from 'src/components/Common';
import { Mixpanel } from '../../Mixpanel';


class ResetPasswordStage1 extends Component {
  constructor() {
    super();
    this.state = {
      email: '',
      emailErrors: [],
      success: false,
      resetPwdInProgress: false,
    }
  }

  resetPassword = () => {
    Mixpanel.track('Reset password')
    this.setState({ resetPwdInProgress: true });
    const email = this.props.email || this.state.email;
    Auth.resetPassword(email)
      .then(() => {
        this.setState({ resetPwdInProgress: false, success: true });
      })
      .catch(() => {
        this.setState({ resetPwdInProgress: false });
        toast.error('Что-то пошло не так :(');
      })
  }

  handleInputChange = (e) => {
    if (this.props.email) {
      this.setState({ emailErrors: [] })
      return;
    }
    this.setState({ email: e.target.value, emailErrors: [] });
  }

  render() {
    const value = this.props.email || this.state.email;
    return (
      <div className="modal reset-password">
        {this.state.success ? (
          <h1>Информация для смены пароля была отправлена на почту.</h1>
        ) : (
            <div>
              <h1>Смена пароля</h1>
              <Input className="modal--input-block modal--input-block__column"
                labelText="Почта"
                name="email"
                placeholder="hacker@mail.ru"
                value={value}
                onChange={this.handleInputChange}
                errors={this.state.emailErrors}
                disabled={!!this.props.email}
              />
              <SaveBtn saveText="Сбросить" cancelText="Отменить"
                onSave={this.resetPassword} onCancel={this.props.closeModal}
                disabled={this.state.resetPwdInProgress} />
            </div>
          )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    email: state.user.email,
  }
}

ResetPasswordStage1.propTypes = {
  email: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, {})(ResetPasswordStage1);



// WEBPACK FOOTER //
// ./src/components/Modal/ResetPassword/ResetPasswordStage1.js